import { Input, Select, Space, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

export function AuditLogFilters({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusChange,
  moduleFilter,
  onModuleChange,
  dateRange,
  onDateRangeChange,
  debouncedSearch,
}) {
  const disabledDate = (current) => {
    if (!current) return false;
    const today = dayjs().endOf('day');
    const thirtyDaysAgo = dayjs().subtract(30, 'day').startOf('day');
    return current.isAfter(today) || current.isBefore(thirtyDaysAgo);
  };
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 16,
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Input
        placeholder="Search by session ID, module, log name..."
        prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{ maxWidth: 400, flex: 1 }}
        allowClear
      />

      <Space wrap>
        <Select
          value={statusFilter}
          className="filter-select-field"
          onChange={onStatusChange}
          style={{
            width: 160,
            border: "1px solid #d9d9d9 !important",
            borderColor: "#d9d9d9 !important",
          }}
          options={[
            { value: "all", label: "All Statuses" },
            { value: "success", label: "Confirmed" },
            { value: "pending", label: "In Progress" },
            { value: "failed", label: "Failed" },
            { value: "abandoned", label: "Abandoned" },
            { value: "expired", label: "Expired" },
          ]}
        />

        <Select
          value={moduleFilter}
          className="filter-select-field"
          onChange={onModuleChange}
          style={{ width: 180 }}
          options={[
            { value: "all",           label: "All Modules" },
            { value: "Booking", label: "Booking" },
            { value: "Cancelling",    label: "Cancellation" },
            { value: "Rescheduling",  label: "Rescheduling" },
          ]}
        />

        <RangePicker
          value={dateRange}
          onChange={onDateRangeChange}
          allowClear
          format="DD/MM/YYYY"
          placeholder={["Start date", "End date"]}
          disabledDate={disabledDate}
          defaultPickerValue={[dayjs().subtract(1, 'month'), dayjs()]}
        />
      </Space>
    </div>
  );
}
